import React, { useState } from "react";
import { Checkbox } from "@telia/teddy";
import { ModalDialog } from "../../../../components";
import _get from "lodash/get";
import { connect, useDispatch } from "react-redux";
import { AgreementToKeep, RootState } from "../../../../../../models";
import { setKeepAgreement } from "../../../../checkout/state/actions/transferOwnershipActions";
import { getTransferAgreementsToKeep } from "../../../../checkout/state/selectors/accountSelectors";
import TEXT from "../../../text-consts";
import { isSwitchAgreement, isSwitchPlusInsurance } from "../../../utils";
import "./KeepAgreementCheckbox.less";

interface StateProps {
    agreementsToKeep: AgreementToKeep;
}

interface KeepAgreementCheckboxProps extends StateProps {
    agreementType: string;
    insuranceType?: string;
    legalOwner: string;
}

const getModalText = (agreementType: string, legalOwner: string, insuranceType?: string) => {
    if (!isSwitchAgreement(agreementType)) {
        return TEXT.SUMMARY.RELATED_INFORMATION.LEASE_KEEP_AGREEMENT_MODAL_TEXT(legalOwner);
    }

    const switchText = TEXT.SUMMARY.RELATED_INFORMATION.SWITCH_KEEP_AGREEMENT_MODAL_TEXT(legalOwner);
    const switchPlusInsuranceText = TEXT.SUMMARY.RELATED_INFORMATION.SWITCH_KEEP_AGREEMENT_MODAL_PLUS_INSURANCE_TEXT;

    return isSwitchPlusInsurance(insuranceType) ? switchText + switchPlusInsuranceText : switchText;
};

const KeepAgreementCheckbox: React.FC<KeepAgreementCheckboxProps> = ({
    agreementType,
    legalOwner,
    insuranceType,
    // Redux (data)
    agreementsToKeep,
}) => {
    const dispatch = useDispatch();

    const [showAgreementModal, setShowAgreementModal] = useState(false);

    const checkboxText = isSwitchAgreement(agreementType)
        ? TEXT.SUMMARY.RELATED_INFORMATION.SWITCH_KEEP_AGREEMENT(legalOwner)
        : TEXT.SUMMARY.RELATED_INFORMATION.LEASE_KEEP_AGREEMENT(legalOwner);
    const modalText = getModalText(agreementType, legalOwner, insuranceType);

    const isChecked = _get(agreementsToKeep, agreementType, false);

    return (
        <div className="keep-agreement-checkbox">
            <Checkbox key={checkboxText}>
                <Checkbox.Trigger
                    checked={isChecked}
                    onCheckedChange={(): void =>
                        isChecked ? dispatch(setKeepAgreement(agreementType, false)) : setShowAgreementModal(true)
                    }
                />
                <div dangerouslySetInnerHTML={{ __html: checkboxText }} />
            </Checkbox>
            {showAgreementModal && (
                <ModalDialog
                    size="medium"
                    name="keep-agreement-modal"
                    closeText="Tilbake"
                    submitText="ok, ikke overfør avtalen"
                    submitKind="secondary"
                    onClose={(): void => setShowAgreementModal(false)}
                    onSubmit={(): void => {
                        dispatch(setKeepAgreement(agreementType, !_get(agreementsToKeep, agreementType, false)));
                        setShowAgreementModal(false);
                    }}
                >
                    {modalText}
                </ModalDialog>
            )}
        </div>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    agreementsToKeep: getTransferAgreementsToKeep(state),
});

export default connect(mapStateToProps)(KeepAgreementCheckbox);
